import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import { generateEntityWithChildIds } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export const createSearchResults = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): SearchResultsInterface => {
  const entity: SearchResultsInterface = {
    ...generateEntityWithChildIds(
      EntityTypeEnum.SearchResults,
      parentId,
      masterBlockId,
    ),

    maxItems: 10,

    card: {
      padding: {
        paddingTop: 24,
        paddingRight: 0,
        paddingBottom: 24,
        paddingLeft: 0,
      },
      border: {
        color: 'rgba(229, 231, 235, 1)',
        style: BorderStyleEnum.solid,
        width: 1,
        type: BorderTypeEnum.bottomOnly,
      },
    },

    total: {
      fontSize: 18,
      lineHeight: 22,
      mobileFontSize: 16,
      mobileLineHeight: 24,
      fontWeight: '500',
      color: 'rgba(31, 41, 55, 1)',
      textAlign: 'left',
    },

    title: {
      fontSize: 20,
      lineHeight: 28,
      mobileFontSize: 16,
      mobileLineHeight: 22,
      fontWeight: '700',
      color: 'rgba(31, 41, 55, 1)',
      textAlign: 'left',
      margin: {
        marginTop: 0,
        marginRight: 0,
        marginBottom: 15,
        marginLeft: 0,
      },
    },

    text: {
      fontSize: 16,
      lineHeight: 28,
      mobileFontSize: 12,
      mobileLineHeight: 20,
      fontWeight: '400',
      color: 'rgba(31, 41, 55, 1)',
      textAlign: 'left',
      margin: {
        marginTop: 0,
        marginRight: 0,
        marginBottom: 32,
        marginLeft: 0,
      },
    },

    date: {
      fontSize: 14,
      lineHeight: 20,
      mobileFontSize: 12,
      mobileLineHeight: 16,
      fontWeight: '600',
      color: 'rgba(107, 114, 128, 1)',
      textAlign: 'left',
    },

    pagination: {
      activeColor: 'rgba(0, 165, 255, 1)',
      activeBackgroundColor: 'rgba(255, 255, 255, 1)',
      inactiveColor: 'rgba(85, 95, 110, 1)',
      inactiveBackgroundColor: 'rgba(228, 232, 238, 1)',
    },
  }

  return entity
}
